import React from 'react';
export function DataDirectoryCustomCta() {
  return <section className="py-16 bg-blue-50 border-y border-blue-100" data-id="element-697">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-698">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-699">
          Need custom data or can't find your category?
        </h2>
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-700">
          We can provide tailored local business listings for your specific
          needs or add new business categories to our database.
        </p>
        <a href="https://www.openmart.com/contact" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 text-base font-bold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors" data-id="element-701">
          Contact us for custom solutions
        </a>
      </div>
    </section>;
}